import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalReservationComponent } from '../../shared/components/modal-reservation/modal-reservation.component';

@Component({
    selector: 'madero-reservation',
    imports: [],
    templateUrl: './reservation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './reservation.component.scss'
})
export class ReservationComponent implements OnInit {

  constructor(private dialog: MatDialog){}

  ngOnInit(): void {
    this.onOpenRegister();
  }

  onOpenRegister(): void{
    this.dialog
      .open(ModalReservationComponent, {
        width: '550px',
        data: { editMode: false },
        disableClose: true
      })
      .afterClosed()
      .subscribe((response) => { console.log('Close: ', response); });
  }
}
